import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { GrooveActionDirective } from '@groove/angular';
import { DATA_CONFIG } from '../../injection-tokens';

@Component({
  selector: 'app-header-cta',
  imports: [GrooveActionDirective],
  templateUrl: './header-cta.component.html',
  styleUrl: './header-cta.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderCtaComponent {
  private readonly dataConfig = inject(DATA_CONFIG);
  protected readonly phoneHref = this.dataConfig.phoneHref;
  protected readonly emailHref = this.dataConfig.emailHref;
}
